import { QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider } from "react-router-dom"
import { queryClient } from "../config/query"
import router from "./router"
import "./app.css"
import { Toaster } from "@/components/ui/sonner"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import CosmosConfig from "@/modules/cosmos/components/cosmos-config"
import LaunchDarklyContextProvider from "@/providers/launch-darkly"
import MixPanelProvider from "@/providers/mixpanel"
import DateFnsProvider from "@/providers/date-fns"

export default function App() {
  return (
    <MixPanelProvider>
      <DateFnsProvider />
      <QueryClientProvider client={queryClient}>
        <CosmosConfig>
          <LaunchDarklyContextProvider />
          <RouterProvider router={router} />
          <Toaster richColors position="top-center" />
          <ReactQueryDevtools initialIsOpen={false} />
        </CosmosConfig>
      </QueryClientProvider>
    </MixPanelProvider>
  )
}
